import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisEmbeddedRoadmapRoute: InvariantJiraRoute = {
	name: 'polaris-embedded-roadmap',
	path: '/jira/polaris/embedded/roadmaps/:collectionUUID/view/:resource?',
	query: ['selectedIssue?'],
	exact: true,
};
